import { Link } from 'react-router';
import { useT } from '@/app/prefs';

export function NotFoundPage() {
  const t = useT();

  return (
    <main style={{ display: 'grid', placeItems: 'center', minHeight: '100vh', padding: 24 }}>
      <div style={{ textAlign: 'center' }}>
        <h1 style={{ fontSize: 42, margin: '0 0 4px' }}>404</h1>
        <p className="sn-muted" style={{ marginBottom: 16 }}>
          {t.common.notFound}
        </p>
        <Link to="/" className="btn btn-primary">
          {t.common.backHome}
        </Link>
      </div>
    </main>
  );
}
